import { useSearchParams } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

import type { Expensable } from 'modules/expenses/components/expenses/DataTable/types'
import { useExpensesNavigation } from 'modules/expenses/hooks/useExpensesNavigation'

interface DetailProps {
  id: string
  effectiveOn: string
  amount: Expensable['amount']
  currency: Expensable['currency']
  owner?: Expensable['owner']
}

export const Detail = ({ id, amount, currency, effectiveOn, owner }: DetailProps) => {
  const {
    access: { locale },
  } = useCurrentSession()
  const { navigation } = useExpensesNavigation()
  const [searchParams] = useSearchParams()

  return (
    <Button.Router
      aria-label={i18n.t('expenses_v2.list.actions.see_expense_details_with_owner', {
        amount: MoneyWithCurrency({
          optionalDecimals: true,
          amount: Number(amount),
          currency,
          locale,
        }),
        date: dateBackendDateTimeToUI(effectiveOn),
        ownerName: owner?.access?.fullName,
      })}
      to={{ pathname: navigation.helpers.expensableDetail(id), search: searchParams.toString() }}
      type="secondary"
      iconName="arrow-right"
    />
  )
}
